const makeCalculateWidth = (maxValue) => {
  return (value) => {
    const percentage = (value * 89) / maxValue;
    return `${percentage}%`;
  };
};

export default makeCalculateWidth;
